// removed by extract-text-webpack-plugin
module.exports = {"component":"_1Ga9OnXMxT-C68_2vuwG1f"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FixedSecondaryHeaderBar/FixedSecondaryHeaderBar.css
// module id = 1295
// module chunks = 0